<template>
    <div class="d-flex align-items-center" v-if="!snapshotView">
        <span class="me-1 ms-auto">
            <span class="badge badge-pill badge-gray"> New </span>
        </span>
        <a href="https://www.cdc.gov/coronavirus/2019-ncov/index.html" rel="noopener noreferrer" target="_blank">
            COVID-19: CDC Coding Guidance
        </a>
        <button
            class="btn btn-primary btn-xs ms-2"
            @click="addDiagnosis()"
            v-if="limit < 0 || diagnosis.length < limit"
            :disabled="isViewDetailsRequested"
        >
            Add Diagnosis
        </button>
    </div>
    <div class="mt-2">
        <table class="table table-responsive-md border border-gray overflow-auto">
            <thead>
                <tr class="bg-table-header">
                    <th>ICD-10 Code</th>
                    <th>Description</th>
                    <th>Start Date</th>
                    <th v-if="snapshotView || (!hideResolved && historyView)">
                        {{ historyView ? "Resolution" : "Resolved" }} Date
                    </th>
                    <th class="text-end">Actions</th>
                </tr>
            </thead>
            <!--Empty Table-->
            <TableEmpty
                v-if="diagnosis.length == 0 && newDiagnosis.length == 0"
                :col-span="columns"
                component="diagnoses"
                secondary-message="No Diagnoses Found"
            />
            <!--Existing Diagnoses-->
            <DiagnosisTableRow
                v-for="(diag, index) of activeDiagnosis"
                :index="index"
                :key="diag.Id"
                :diag="diag"
                :move-diagnosis-up="moveDiagnosis"
                :make-primary="makePrimary"
                :move-diagnosis-down="moveDiagnosis"
                :resolve-diagnosis="resolveDiagnosis"
                :first="index === 0"
                :last="index === activeDiagnosis.length - 1"
                :id="id"
                :snapshot-view="snapshotView"
                :delete-diagnosis="deleteDiagnosis"
                :application="application"
                :history-view="historyView"
                :hide-resolved="hideResolved"
                :prevent-future="preventFuture"
                :is-view-details-requested="isViewDetailsRequested"
            />
            <!--New Diagnoses-->
            <DiagnosisTableRow
                v-for="(diag, index) of newDiagnosis"
                :index="index"
                :key="diag.Id"
                :diag="diag"
                :updateDiag="updateDiag"
                v-model:is-add-requested="isAddRequested"
                :save-new-diagnosis="saveNewDiagnosis"
                v-show="newDiagnosis.length > 0"
                :cancel-save-new-diagnosis="cancelSaveNewDiagnosis"
                :is-new-terminal="isNewTerminal"
                :snapshot-view="snapshotView"
                :application="application"
                :history-view="historyView"
                :hide-resolved="hideResolved"
                :prevent-future="preventFuture"
                :is-view-details-requested="isViewDetailsRequested"
            />
        </table>
    </div>
</template>

<script lang="ts" src="./DiagnosisTable.ts"></script>
